var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.cards),function(card){return _c('v-col',{key:card.id,staticClass:"card-styling",attrs:{"cols":"12","md":"4"}},[_c('Card',{attrs:{"card":card}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }